import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  ctaLight: {
    color: "#ffffff",
    backgroundColor: "rgba(255, 255, 255, 0.08)",
    fontWeight: 600,
    border: "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "10px",
    textTransform: "none",
    fontSize: "15px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.16)",
      borderColor: "rgba(255, 255, 255, 0.4)",
    },
  },
  ctaDark: {
    color: "#0f172a",
    backgroundColor: "#ffffff",
    fontWeight: 600,
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    textTransform: "none",
    fontSize: "15px",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.04)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#f8fafc",
      borderColor: "#cbd5e1",
    },
  },
}));

export default function SalesCTA(props) {
  const classes = useStyles();

  return (
    <Button
      style={{
        width: props.width,
        height: props.height,
        padding: props.padding ?? "12px 24px",
        marginTop: props.marginTop ?? "0",
      }}
      className={props.theme === "light" ? classes.ctaDark : classes.ctaLight}
      variant="outlined"
      href="https://wa.me/6287777077771?text=Halo,%20mau%20tanya-tanya%20tentang%20UR%20dong"
      target="_blank"
      rel="noreferrer"
    >
      <span
        style={{
          fontWeight: 600,
          fontSize: props.fontSize ? Number(props.fontSize) : 15,
          color: props.fontColor ?? (props.theme === "light" ? "#0f172a" : "#ffffff"),
        }}
      >
        {props.text ?? "Hubungi Sales"}
      </span>
    </Button>
  );
}
